import React from 'react';
import { ModelListEditor } from '@leverege/ui-plugin';
import { Text, Flex, Button, Pane } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { PieChartModel, ValueRangeModel } from "../../models/index.js";
import S from './ValueRangesEditor.css';
import ValueRangeListRenderer from "./ValueRangeListRenderer.js";
const {
  t
} = ns('ui-attributes-graphs.editors.ValueRangeEditor');
function contentHeader(item) {
  if (item == null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Text, {
    variant: "subtitle"
  }, t('valueRange'), " ", item?.name === t('setRange') ? null : item?.name);
}
function ValueRangesEditor(props) {
  const {
    value,
    onChange,
    eventData,
    objectType
  } = props;
  if (value == null) {
    return null;
  }
  const onAddRange = () => {
    const nModel = PieChartModel.valueRanges().add(value, ValueRangeModel.create({
      name: t('setRange')
    }));
    onChange({
      value: nModel.valueRanges,
      data: eventData,
      oldValue: value
    });
  };
  const header = () => {
    return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      className: S.addButton,
      onClick: onAddRange,
      icon: "fa fa-plus",
      iconPosition: "start"
    }, t('addRange')));
  };
  const forward = e => {
    onChange({
      value: e.value.valueRanges,
      data: 'setValueRanges'
    });
  };
  const Model = {
    ...PieChartModel.valueRanges(),
    indexOf: PieChartModel.indexOfValueRange
  };
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "editor",
    className: S.editor
  }, /*#__PURE__*/React.createElement(ModelListEditor, {
    value: value,
    paneVariant: "",
    listClassName: S.list,
    listHeader: header,
    model: Model,
    renderer: ValueRangeListRenderer,
    selectionHeader: contentHeader,
    onChange: forward,
    selectedProps: {
      objectType
    }
  }));
}
export default ValueRangesEditor;